/**
=========================================================
* Material Kit 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import Faq from "pages/Faq";
import TherapistProgram from "pages/TherapistProgram";
import FindATherapist from "pages/FindATherapist";
import TherapistBioEditable from "pages/TherapistBioEditable";
// import Blog from "pages/Blog";
import AboutUs from "pages/AboutUs";
import TherapyHub from "pages/TherapyHub";
import AuthPage from "pages/Auth";
import ShopPage from "pages/Shop";
import EHRPackagesPage from "pages/EHRPackages";
import InsuranceCheckCoverage from "pages/InsuranceCheckCoverage";
import OnlineAssessmentHub from "pages/OnlineAssessmentHub";
import InsuranceOptionsHub from "pages/InsuranceOptionsHub";
import Blog from "pages/Blog";

const routes = [
  {
    name: "Services",
    collapse: [
      {
        key: "online-therapy",
        name: "Online Therapy",
        submenu: [
          { key: "All-Online-Therapy", name: "All Online Therapy", route: "/online-therapy" },
          { key: "individual", name: "Individual therapy", route: "/online-therapy/individual-therapy" },
          { key: "couples", name: "Couples therapy", route: "/online-therapy/couples-therapy" },
          { key: "veterans", name: "Veterans therapy", route: "/online-therapy/veterans" },
          { key: "lgbtqia", name: "LGBTQIA+ therapy", route: "/online-therapy/lgbtqia" },
        ],
      },
      {
        key: "treatments",
        name: "Treatments",
        submenu: [
          { key: "All Treatments", name: "All Treatments", route: "/treatment" },
          { key: "Generalized Anxiety Disorder", name: "Generalized Anxiety Disorder", route: "/treatment/generalized-anxiety-disorder" },
          { key: "Insomnia", name: "Insomnia", route: "/treatment/insomnia" },
          { key: "Depression", name: "Depression", route: "/treatment/depression" },
          { key: "Treatment-Resistant Depression", name: "Treatment-Resistant Depression", route: "/treatment/treatment-resistant-depression" },
          { key: "Bipolar Disorder", name: "Bipolar Disorder", route: "/treatment/bipolar-disorder" },
          { key: "Post-Traumatic Stress Disorder", name: "Post-Traumatic Stress Disorder", route: "/treatment/post-traumatic-stress-disorder" },
          {
            key: "Attention-Deficit-Hyperactivity Disorder",
            name: "Attention-Deficit-Hyperactivity Disorder",
            route: "/treatment/attention-deficit-hyperactivity-disorder",
          },
          { key: "Obsessive-Compulsive Disorder", name: "Obsessive-Compulsive Disorder", route: "/treatment/obsessive-compulsive-disorder" },
          { key: "Panic Disorder", name: "Panic Disorder", route: "/treatment/panic-disorder" },
          { key: "Social Anxiety Disorder", name: "Social Anxiety Disorder", route: "/treatment/social-anxiety-disorder" },
        ],
      },
      {
        key: "ketamine-therapy",
        name: "Ketamine Therapy",
        submenu: [
          {
            name: "Ketamine Therapy",
            route: "/ketamine-therapy",
            component: <TherapyHub />,
            key: "ketamine-therapy",
          },
          {
            name: "Ketamine Packages",
            route: "/ketamine-therapy/packages",
            component: <ShopPage />,
            key: "our-packages",
          },
          // medication options
        ],
      },
      {
        key: "psilocybin-therapy",
        name: "Psilocybin Therapy",
        route: "/psilocybin-therapy",
        component: <TherapyHub />,
      },
    ],
  },
  {
    name: "Insurance Options",
    collapse: [
      {
        name: "All Insurance Providers",
        route: "/insurance-options",
        component: <InsuranceOptionsHub />,
        key: "insurance-options",
      },
      {
        name: "Aetna",
        route: "/insurance-options/aetna",
        key: "aetna",
      },
      {
        name: "Anthem",
        route: "/insurance-options/anthem",
        key: "anthem",
      },
      {
        name: "Cigna",
        route: "/insurance-options/cigna",
        key: "cigna",
      },
      {
        name: "Oscar",
        route: "/insurance-options/oscar",
        key: "oscar",
      },
      {
        name: "United Healthcare",
        route: "/insurance-options/united-healthcare",
        key: "united-healthcare",
      },
      {
        name: "Oxford",
        route: "/insurance-options/oxford",
        key: "oxford",
      },
    ],
  },
  {
    name: "For Patients",
    collapse: [
      {
        name: "Find A Therapist",
        route: "/partner-providers",
        component: <FindATherapist />,
        key: "find-a-ketamine-therapist",
      },
      {
        name: "Check Coverage",
        route: "/insurance-options/check-coverage",
        component: <InsuranceCheckCoverage />,
        key: "check-coverage",
      },
      {
        name: "Account Order Information",
        route:
          process.env.REACT_APP_ENV === "production"
            ? process.env.REACT_APP_LIVE_STRIPE_CUSTOMER_PORTAL_PATH
            : process.env.REACT_APP_STRIPE_CUSTOMER_PORTAL_PATH,
        key: "order-info",
      },
    ],
  },
  {
    name: "For Therapists",
    collapse: [
      {
        name: "Therapist Referral Program",
        route: "/partners",
        component: <TherapistProgram />,
        key: "partners",
      },
      {
        name: "Therapist Profile",
        route: "/therapist-bio-editable",
        component: <TherapistBioEditable />,
        key: "therapist-program",
        protected: true,
        requiredRole: "partnered-therapist",
      },
      {
        name: "Partner Education Program",
        route: "https://partners.almadelic.com/therapist-education-get-started",
        key: "Education Program",
        protected: true,
        requiredRole: "partnered-therapist",
      },
      {
        name: "Therapist Profile Sign In",
        route: "/therapist-auth/sign-in",
        component: <AuthPage />,
        key: "auth-page",
      },
      {
        name: "Almadelic EHR",
        route: "/partners/ehr-packages",
        component: <EHRPackagesPage />,
        key: "ehr-packages",
      },
    ],
  },
  {
    name: "Resources",
    collapse: [
      {
        name: "About Us",
        route: "/about-us",
        component: <AboutUs />,
        key: "about-us",
      },
      {
        name: "Online Assessments",
        route: "/online-assessment",
        component: <OnlineAssessmentHub />,
        key: "online-assessment",
      },
      {
        name: "Mental Health Blog",
        key: "mental-health-blog",
        route: "/blog",
        component: <Blog />,
      },
      {
        name: "Almadelic FAQs",
        route: "/faq",
        component: <Faq />,
        key: "faq",
      },
      {
        name: "Ketamine Therapy FAQs",
        route: "/ketamine-therapy/faq",
        component: <Faq />,
        key: "ketamine-therapy-faq",
      },
    ],
  },
];

export default routes;
